export default {
	'pages.layouts.userLayout.title': '基于前后端分离 Web 设计规范的后台管理解决方案',
	'pages.login.accountLogin.tab': '账户密码登录',
	'pages.login.accountLogin.errorMessage': '错误的用户名和密码',
	'pages.login.failure': '登录失败，请重试！',
	'pages.login.success': '登录成功！',
	'pages.login.username.placeholder': '用户名',
	'pages.login.username.required': '用户名是必填项！',
	'pages.login.password.placeholder': '密码',
	'pages.login.password.required': '密码是必填项！',
	'pages.login.phoneLogin.tab': '手机号登录',
	'pages.login.phoneLogin.errorMessage': '验证码错误',
	'pages.login.phoneNumber.placeholder': '请输入手机号！',
	'pages.login.phoneNumber.required': '手机号是必填项！',
	'pages.login.phoneNumber.invalid': '不合法的手机号！',
	'pages.login.captcha.placeholder': '请输入验证码！',
	'pages.login.captcha.required': '验证码是必填项！',
	'pages.login.phoneLogin.getVerificationCode': '获取验证码',
	'pages.getCaptchaSecondText': '秒后重新获取',
	'pages.login.rememberMe': '自动登录',
	'pages.login.forgotPassword': '忘记密码 ?',
	'pages.login.submit': '登录',
	'pages.login.loginWith': '其他登录方式 :',
	'pages.login.registerAccount': '注册账户',
	'pages.welcome.advancedComponent': '高级表格',
	'pages.welcome.link': '欢迎使用',
	'pages.welcome.advancedLayout': '高级布局',
	'pages.welcome.alertMessage': '更快更强的重型组件，已经发布。',
	'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
	'pages.admin.subPage.alertMessage': 'Umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
	'pages.searchTable.createForm.newRule': '新建规则',
	'pages.searchTable.updateForm.ruleConfig': '规则配置',
	'pages.searchTable.updateForm.basicConfig': '基本信息',
	'pages.searchTable.updateForm.rulesProps.ruleName': '规则名称',
	'pages.searchTable.updateForm.rulesProps.ruleDesc': '规则描述',
	'pages.searchTable.updateForm.rulesProps.ruleProps': '规则属性',
	'pages.searchTable.updateForm.rulesProps.targetLabel': '监控对象',
	'pages.searchTable.updateForm.rulesProps.templateLabel': '规则模板',
	'pages.searchTable.updateForm.rulesProps.typeLabel': '规则类型',
	'pages.searchTable.updateForm.rulesProps.timeLabel': '开始时间',
	'pages.searchTable.updateForm.rulesProps.frequencyLabel': '调度周期',
	'pages.searchTable.updateForm.object': '配置对象',
	'pages.searchTable.updateForm.ruleDesc': '请输入至少五个字符的规则描述！',
	'pages.searchTable.ruleName': '规则名称为必填项',

	// 管理员管理模块
	'pages.admin.management.title': '管理员管理',
	'pages.admin.management.list.title': '管理员列表',
	'pages.admin.management.add': '新增管理员',
	'pages.admin.management.edit': '编辑管理员',
	'pages.admin.management.delete.confirm': '确定要删除该管理员吗？',
	'pages.admin.management.delete.success': '删除成功',
	'pages.admin.management.save.success': '保存成功',
	'pages.admin.management.form.username': '用户名',
	'pages.admin.management.form.username.placeholder': '请输入用户名',
	'pages.admin.management.form.username.required': '请输入用户名',
	'pages.admin.management.form.name': '姓名',
	'pages.admin.management.form.name.placeholder': '请输入姓名',
	'pages.admin.management.form.name.required': '请输入姓名',
	'pages.admin.management.form.email': '邮箱',
	'pages.admin.management.form.email.placeholder': '请输入邮箱',
	'pages.admin.management.form.email.required': '请输入邮箱',
	'pages.admin.management.form.email.invalid': '邮箱格式不正确',
	'pages.admin.management.form.password': '密码',
	'pages.admin.management.form.password.placeholder': '请输入密码',
	'pages.admin.management.form.password.required': '请输入密码',
	'pages.admin.management.form.password.min': '密码至少6位',
	'pages.admin.management.form.role': '角色',
	'pages.admin.management.form.role.placeholder': '请选择角色',
	'pages.admin.management.form.role.required': '请选择角色',
	'pages.admin.management.form.status': '状态',
	'pages.admin.management.form.status.active': '启用',
	'pages.admin.management.form.status.inactive': '禁用',
	'pages.admin.management.table.id': 'ID',
	'pages.admin.management.table.username': '用户名',
	'pages.admin.management.table.name': '姓名',
	'pages.admin.management.table.email': '邮箱',
	'pages.admin.management.table.role': '角色',
	'pages.admin.management.table.status': '状态',
	'pages.admin.management.table.lastLogin': '最后登录',
	'pages.admin.management.table.createdAt': '创建时间',
	'pages.admin.management.table.actions': '操作',
	'pages.admin.management.table.actions.edit': '编辑',
	'pages.admin.management.table.actions.delete': '删除',

	// 登录日志
	'pages.admin.loginLogs.title': '登录日志',
	'pages.admin.loginLogs.list.title': '登录日志列表',
	'pages.admin.loginLogs.detail.title': '登录日志详情',
	'pages.admin.loginLogs.table.id': 'ID',
	'pages.admin.loginLogs.table.admin': '管理员',
	'pages.admin.loginLogs.table.username': '用户名',
	'pages.admin.loginLogs.table.status': '登录状态',
	'pages.admin.loginLogs.table.status.success': '成功',
	'pages.admin.loginLogs.table.status.failed': '失败',
	'pages.admin.loginLogs.table.ip': 'IP地址',
	'pages.admin.loginLogs.table.location': '地理位置',
	'pages.admin.loginLogs.table.browser': '浏览器',
	'pages.admin.loginLogs.table.loginTime': '登录时间',
	'pages.admin.loginLogs.table.failureReason': '失败原因',
	'pages.admin.loginLogs.table.actions': '操作',
	'pages.admin.loginLogs.table.actions.detail': '详情',
	'pages.admin.loginLogs.filter.admin.placeholder': '选择管理员',
	'pages.admin.loginLogs.filter.dateRange.placeholder.start': '开始时间',
	'pages.admin.loginLogs.filter.dateRange.placeholder.end': '结束时间',
	'pages.404.subTitle': '抱歉，您访问的页面不存在。',
	'pages.404.buttonText': '返回首页',
	'pages.searchTable.titleDesc': '描述',
	'pages.searchTable.titleCallNo': '服务调用次数',
	'pages.searchTable.titleStatus': '状态',
	'pages.searchTable.nameStatus.default': '关闭',
	'pages.searchTable.nameStatus.running': '运行中',
	'pages.searchTable.nameStatus.online': '已上线',
	'pages.searchTable.nameStatus.abnormal': '异常',
	'pages.searchTable.titleUpdatedAt': '上次调度时间',
	'pages.searchTable.exception': '请输入异常原因！',
	'pages.searchTable.titleOption': '操作',
	'pages.searchTable.config': '配置',
	'pages.searchTable.subscribeAlert': '订阅警报',
	'pages.searchTable.title': '查询表格',
	'pages.searchTable.new': '新建',
	'pages.searchTable.chosen': '已选择',
	'pages.searchTable.item': '项',
	'pages.searchTable.totalServiceCalls': '服务调用次数总计',
	'pages.searchTable.tenThousand': '万',
	'pages.searchTable.batchDeletion': '批量删除',
	'pages.searchTable.batchApproval': '批量审批',

	// SMTP邮件转发设置
	'pages.site.smtp.title': 'SMTP邮件转发设置',
	'pages.site.smtp.description': '配置SMTP服务器用于系统邮件发送',
	'pages.site.smtp.load.error': '加载SMTP配置失败，请稍后重试',
	'pages.site.smtp.form.server': 'SMTP服务器',
	'pages.site.smtp.form.server.placeholder': '请输入SMTP服务器地址',
	'pages.site.smtp.form.server.required': '请输入SMTP服务器地址',
	'pages.site.smtp.form.port': 'SMTP端口',
	'pages.site.smtp.form.port.placeholder': '请输入SMTP端口',
	'pages.site.smtp.form.port.required': '请输入SMTP端口',
	'pages.site.smtp.form.username': 'SMTP用户名',
	'pages.site.smtp.form.username.placeholder': '请输入SMTP用户名',
	'pages.site.smtp.form.username.required': '请输入SMTP用户名',
	'pages.site.smtp.form.password': 'SMTP密码',
	'pages.site.smtp.form.password.placeholder': '请输入SMTP密码',
	'pages.site.smtp.form.password.required': '请输入SMTP密码',
	'pages.site.smtp.form.fromEmail': '发件人邮箱',
	'pages.site.smtp.form.fromEmail.placeholder': '请输入发件人邮箱',
	'pages.site.smtp.form.fromEmail.required': '请输入发件人邮箱',
	'pages.site.smtp.form.fromEmail.invalid': '邮箱格式不正确',
	'pages.site.smtp.form.fromName': '发件人名称',
	'pages.site.smtp.form.fromName.placeholder': '请输入发件人名称',
	'pages.site.smtp.form.fromName.required': '请输入发件人名称',
	'pages.site.smtp.form.ssl': '启用SSL',
	'pages.site.smtp.form.ssl.description': '是否启用SSL加密连接',
	'pages.site.smtp.form.testEmail': '测试邮箱',
	'pages.site.smtp.form.testEmail.placeholder': '请输入测试邮箱地址',
	'pages.site.smtp.form.testEmail.invalid': '邮箱格式不正确',
	'pages.site.smtp.button.save': '保存配置',
	'pages.site.smtp.button.test': '发送测试邮件',
	'pages.site.smtp.button.reset': '重置',
	'pages.site.smtp.save.success': '配置保存成功',
	'pages.site.smtp.save.error': '配置保存失败',
	'pages.site.smtp.test.success': '测试邮件发送成功',
	'pages.site.smtp.test.error': '测试邮件发送失败',
	'pages.site.smtp.form.toEmail': '收件人邮箱',
	'pages.site.smtp.form.toEmail.placeholder': '请输入收件人邮箱',
	'pages.site.smtp.form.toEmail.required': '请输入收件人邮箱',
	'pages.site.smtp.form.toEmail.invalid': '邮箱格式不正确',

	// 网站信息设置
	'pages.site.websiteInfo.title': '网站信息设置',
	'pages.site.websiteInfo.description': '配置网站基本信息、SEO设置和联系方式',
	'pages.site.websiteInfo.section.company': '公司信息',
	'pages.site.websiteInfo.section.seo': 'SEO设置',
	'pages.site.websiteInfo.section.contact': '联系信息',
	'pages.site.websiteInfo.section.analytics': '统计分析',
	'pages.site.websiteInfo.form.language': '当前语言',
	'pages.site.websiteInfo.form.language.description': '系统当前使用的语言版本',
	'pages.site.websiteInfo.form.companyName': '公司名称',
	'pages.site.websiteInfo.form.companyName.placeholder': '请输入公司名称',
	'pages.site.websiteInfo.form.companyName.required': '请输入公司名称',
	'pages.site.websiteInfo.form.logo': '网站Logo',
	'pages.site.websiteInfo.form.logo.description': '支持JPG、PNG格式，建议尺寸200x60像素',
	'pages.site.websiteInfo.form.logo.tip': '支持JPG、PNG格式，建议尺寸200x60像素',
	'pages.site.websiteInfo.form.logo.upload': '点击上传',
	'pages.site.websiteInfo.form.logo.change': '更换Logo',
	'pages.site.websiteInfo.form.seoTitle': 'SEO标题',
	'pages.site.websiteInfo.form.seoTitle.placeholder': '请输入网站SEO标题',
	'pages.site.websiteInfo.form.seoTitle.required': '请输入SEO标题',
	'pages.site.websiteInfo.form.seoKeywords': 'SEO关键词',
	'pages.site.websiteInfo.form.seoKeywords.placeholder': '请输入SEO关键词，多个关键词用逗号分隔',
	'pages.site.websiteInfo.form.seoKeywords.required': '请输入SEO关键词',
	'pages.site.websiteInfo.form.seoDescription': 'SEO描述',
	'pages.site.websiteInfo.form.seoDescription.placeholder': '请输入网站SEO描述',
	'pages.site.websiteInfo.form.seoDescription.required': '请输入SEO描述',
	'pages.site.websiteInfo.form.contactPerson': '联系人',
	'pages.site.websiteInfo.form.contactPerson.placeholder': '请输入联系人姓名',
	'pages.site.websiteInfo.form.contactPerson.required': '请输入联系人',
	'pages.site.websiteInfo.form.contactPhone': '联系电话',
	'pages.site.websiteInfo.form.contactPhone.placeholder': '请输入联系电话',
	'pages.site.websiteInfo.form.contactPhone.required': '请输入联系电话',
	'pages.site.websiteInfo.form.contactEmail': '联系邮箱',
	'pages.site.websiteInfo.form.contactEmail.placeholder': '请输入联系邮箱',
	'pages.site.websiteInfo.form.contactEmail.required': '请输入联系邮箱',
	'pages.site.websiteInfo.form.contactEmail.invalid': '邮箱格式不正确',
	'pages.site.websiteInfo.form.contactAddress': '联系地址',
	'pages.site.websiteInfo.form.contactAddress.placeholder': '请输入联系地址',
	'pages.site.websiteInfo.form.contactAddress.required': '请输入联系地址',
	'pages.site.websiteInfo.form.googleAnalytics': 'Google Analytics代码',
	'pages.site.websiteInfo.form.googleAnalytics.placeholder': '请输入Google Analytics跟踪代码',
	'pages.site.websiteInfo.form.googleAnalytics.description':
		'输入完整的Google Analytics跟踪代码，包括<script>标签',
	'pages.site.websiteInfo.form.googleAnalytics.tip':
		'输入完整的Google Analytics跟踪代码，包括<script>标签',
	'pages.site.websiteInfo.button.save': '保存设置',
	'pages.site.websiteInfo.button.reset': '重置',
	'pages.site.websiteInfo.save.success': '网站信息保存成功',
	'pages.site.websiteInfo.save.error': '网站信息保存失败',
	'pages.site.websiteInfo.upload.success': 'Logo上传成功',
	'pages.site.websiteInfo.upload.error': 'Logo上传失败',
	'pages.site.websiteInfo.upload.beforeUpload.size': '图片大小不能超过2MB',
	'pages.site.websiteInfo.upload.beforeUpload.type': '只能上传JPG/PNG格式的图片',
	'pages.site.websiteInfo.section.floatingService': '浮动客服',
	'pages.site.websiteInfo.form.onlineWhatsatsapp': 'WhatsApp',
	'pages.site.websiteInfo.form.onlineWhatsatsapp.placeholder': '请输入WhatsApp',
	'pages.site.websiteInfo.form.onlineWhatsatsapp.tip': '多个账号用英文符号“ / ”分隔',
	'pages.site.websiteInfo.form.onlineEmail': '邮箱',
	'pages.site.websiteInfo.form.onlineEmail.placeholder': '请输入邮箱',
	'pages.site.websiteInfo.form.onlineEmail.tip': '多个邮箱用英文符号“ / ”分隔',
	'pages.site.websiteInfo.form.onlineCode': '客服代码',
	'pages.site.websiteInfo.form.onlineCode.placeholder': '请输入客服代码',
	'pages.site.smtp.form.enable': '启用SMTP',
	'pages.site.smtp.form.enable.description': '是否启用SMTP服务',
};
